import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { User, SignatureFormat, PositionElementEnum, FontEnum } from '@app/models';
import { InitialsNamePipe } from '@app/shared/pipes/initials-name.pipe';
import { SignatureNamePipe } from '@app/shared/pipes/signature-name.pipe';

@Component({
  selector: 'app-signature-preview',
  templateUrl: './signature-preview.component.html',
  styleUrls: ['./signature-preview.component.scss'],
  standalone: false
})
export class SignaturePreviewComponent implements OnChanges {
  @Input() user: User;
  @Input() type?: PositionElementEnum = PositionElementEnum.Signature;
  @Input() font?: FontEnum | string;

  @Input() format?: SignatureFormat | string;
  @Input() text?: string;
  @Input() imageUrl?: string;
  @Input() drawingUrl?: string;

  signatureNamePipe = new SignatureNamePipe();
  initialsPipe = new InitialsNamePipe();
  PositionElementEnum = PositionElementEnum;
  SignatureFormat = SignatureFormat;

  constructor() {
    this.assignDefaultFormatAndImage();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.assignDefaultFormatAndImage();
  }

  get displayName(): string {
    if (this.type === PositionElementEnum.Initials) {
      return this.text || this.initialsPipe.transform(this.user?.name);
    } else {
      return this.text || this.signatureNamePipe.transform(this.user?.name);
    }
  }

  private assignDefaultFormatAndImage() {
    if (this.user) {
      if (!this.format) {
        this.format = this.user.settings.format;
      }
      if (!this.imageUrl) {
        this.imageUrl = this.type === PositionElementEnum.Initials ? this.user.settings.initials : this.user.settings.signature;
      }
      if (!this.drawingUrl) {
        this.drawingUrl = this.type === PositionElementEnum.Initials ? this.user.settings.initials_draw : this.user.settings.signature_draw;
      }
    }
  }
}
